import platformUtilities from '../../modules/platform_utilities.js';
import FlightDatesHelper from '../../modules/flight_dates_helper.js';
import SelectOptionDisabler from "../../modules/select_option_disabler";

angular.module('vastdesk').
  component('budgetSpend', {
    bindings: {
      spendId: '@',
      rateCurrency: '@',
      currencyMetrics: '<',
      multiCurrencyEnabled: '<',
      defaultVastCachingToTrue: '@'
    },
    controller: ['$element', '$rootScope', '$compile', function($element, $rootScope, $compile) {

      var self = this;
      var bodySelector = $('body');
      var budgetsElement;
      var flightDatesElement = $('#flight_dates');
      const flightDatesHelper = new FlightDatesHelper();
      let budgetFlightDatesInactive = false;
      var budgetCapsObjectOptionDisabler;
      var typeToLabelMap = {
        'revenue': 'Revenue:',
        'requests': 'Requests:',
        'impressions': 'Impressions:',
        'completes': 'Completes:',
        'clicks': 'Clicks:',
        'net_cost': 'Net Cost:',
        'gross_cost': 'Gross Cost:',
        'bid_requests': 'Bid Requests:'
      };
      var typeToClassMap = {
        'revenue': 'btn-rev',
        'requests': 'btn-reqs',
        'impressions': 'btn-imps',
        'completes': 'btn-completes',
        'clicks': 'btn-clicks',
        'net_cost': 'btn-net-cost',
        'gross_cost': 'btn-gross-cost',
        'bid_requests': 'btn-bid-requests',
      };

      const cleanNumber = (value) => {
        if (value == null) return '';

        // strip all non-numeric and non-decimal characters
        return value.replace(/[^\d.]/g, '');
      }

      const togglePacingFields = function(add_form) {
        setTimeout(function() {
          const budgetPeriod = add_form.find('.budget-period input:checked').val();
          const flightDateEnabled = $('.flight-dates input:checked').val();


          if (budgetPeriod === 'lifetime' && flightDateEnabled !== 'true' && visibleBudgetFlightDates(add_form).length < 1) {
            add_form.find('.budget_pacing .btn-group label[for$=budget_pacing_]').click();
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_smooth]').addClass('disabled')
                                                                                       .attr('title', 'Add Flight Dates to apply pacing to Lifetime budgets')
                                                                                       .attr('data-placement', 'top')
                                                                                       .tooltip();
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_front_loaded]').addClass('disabled')
                                                                                             .attr('title', 'Add Flight Dates to apply pacing to Lifetime budgets')
                                                                                             .attr('data-placement', 'top')
                                                                                             .tooltip();
          }
          else {
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_smooth]').removeClass('disabled')
                                                                                       .tooltip('dispose')
                                                                                       .removeAttr('title')
                                                                                       .removeAttr('data-placement');
            add_form.find('.budget_pacing .btn-group label[for*=budget_pacing_front_loaded]').removeClass('disabled')
                                                                                             .tooltip('dispose')
                                                                                             .removeAttr('title')
                                                                                             .removeAttr('data-placement');
          }

        }, 0);
      };

      const updateBudgetCapLabels = function(addForm, selectedType) {
        addForm.find('.budget-cap-metric-value-label').each(function() {
          $(this).text(typeToLabelMap[selectedType]);
        });


        addForm.find('.budget-caps:not([style*="display: none"])').each(function(budgetCapIndex, budgetCap) {
          var $budgetCap = $(budgetCap);
          $budgetCap.find('.budget-cap-budget-type .btn').not('.btn-percent').addClass('hidden');

          var buttonToShow = $budgetCap.find('.budget-cap-budget-type .' + typeToClassMap[selectedType]);
          buttonToShow.removeClass('hidden');

          if ($budgetCap.find('.budget-cap-budget-type .btn-percent').hasClass('active')) {
            return;
          }

          $budgetCap.find('.budget-cap-budget-type .btn').removeClass('active');

          var fallbackBtn = $budgetCap.find('.budget-cap-budget-type .btn').not('.btn-percent').not('.hidden');

          if (fallbackBtn.length) {
            fallbackBtn.addClass('active');
            fallbackBtn.find('input[type="radio"]').prop('checked', true);
          }
        });
      }

      const toggleMetricFields = function(add_form) {
        setTimeout(function() {
          const budgetMetric = add_form.find('.budget-metric');
          const completesInput = budgetMetric.find('input[id*=budget_metric_completes]');
          const clicksInput = budgetMetric.find('input[id*=budget_metric_clicks]');
          const allocationBreakdownInput = add_form.find('.allocation-breakdown input');
          const allocationLabel = add_form.find('label[for*=allocation_breakdown]');
          const labelsToToggle = budgetMetric.find('label[for*=budget_metric_clicks], label[for*=budget_metric_completes]');

          const isDisabled = completesInput.is(':checked') || clicksInput.is(':checked');

          allocationBreakdownInput.prop('disabled', isDisabled);
          allocationLabel.toggleClass('disabled-checkbox', isDisabled);

          if (isDisabled) {
            allocationLabel.attr('title', 'Not available for clicks or completes')
                .attr('data-placement', 'top')
                .tooltip();
          } else {
            allocationLabel.tooltip('dispose').removeAttr('title').removeAttr('data-placement');
          }

          labelsToToggle.toggleClass('disabled', allocationBreakdownInput.is(':checked'))
              .each(function() {
                const $label = $(this);
                if (allocationBreakdownInput.is(':checked')) {
                  $label.attr('title', 'Budget type not supported for allocation breakdowns')
                      .attr('data-placement', 'top')
                      .tooltip();
                } else {
                  $label.tooltip('dispose').removeAttr('title').removeAttr('data-placement');
                }
              });
        });
      };

      const toggleFieldVisibilityBasedOnMetric = function(add_form) {
        setTimeout(function() {
          const budgetMetric = add_form.find('input[id*=budget_metric]:checked').val();
          const showCachingField = budgetMetric === 'impressions' || budgetMetric === 'gross_cost' || budgetMetric === 'net_cost';
          add_form.find('.budget_vast_caching_adjustment').toggleClass('hidden', !showCachingField);
          add_form.find('.budget-currency-addon').toggleClass('hidden', !_.includes(self.currencyMetrics, budgetMetric));
          if (self.defaultVastCachingToTrue === 'true' && showCachingField) {
            add_form.find('input[name$="[vast_caching_adjustment]"]').prop('checked', true);
          }
        }, 0);
      };

      const setupBudgetValueFormatting = (add_form) => {
        const budgetMetric = add_form.find('input[id*=budget_metric]:checked').val();
        const budgetValue = add_form.find('input[id*=budget_value]').val();
        const budgetCurrency = add_form.find('select[name*="[budget_value_currency]"]').val()
            || add_form.find('.budget-currency-addon .input-group-text').text().trim();

        const allowDelimiter = _.includes(self.currencyMetrics, budgetMetric) && (!self.multiCurrencyEnabled || budgetCurrency === "USD");

        const clearValue = cleanNumber(budgetValue);
        if (!clearValue) return;

        const parts = clearValue.split('.');
        // only insert commas for the integer part of the value
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const formatted = allowDelimiter
            ? (parts[1] !== undefined ? integerPart + '.' + parts[1] : integerPart)
            : clearValue;

        add_form.find('input[id*=budget_value]').val(formatted);
      };

      const broadcastSupplyAllocationChange = function() {
        setTimeout(function(){
          $rootScope.$broadcast('budgetSupplyAllocationChange');
        }, 0);
      };

      const broadcastBudgetCountChange = function() {
        setTimeout(function(){
          $rootScope.$broadcast('budgetCountChange', {
            spendId: self.spendId
          });
        }, 0);
      };

      const setInitialBudgetCurrency = function(addedBudget) {
        if (self.rateCurrency && self.rateCurrency !== '') {
          addedBudget.find('select[name*="[budget_value_currency]"]').val(self.rateCurrency);
        }
      };

      const setFlightingActive = function(add_form, flightingActive) {
        add_form.find('.flighting-activator').toggleClass('active', flightingActive);
        add_form.find('.flighting-card').toggleClass('hidden', !flightingActive);
      };

      const visibleBudgetFlightDates = function(add_form) {
        return add_form.find('.budget-flight-dates:not([style*="display: none"])').not('.hidden');
      };

      const budgetTimezone = function() {
        return document.querySelector('select[name$="[budget_timezone]"]').value || 'Etc/UTC';
      };

      const setBudgetFlightDatesInactive = (applyScope) => {
        setTimeout(function() {
          const budgetData = _.map($('.budget-group:not([style*="display: none"])'), function(add_form) {
            const budgetFlights = _.map(visibleBudgetFlightDates($(add_form)).find('input[name$="[flight_dates]"]'), function(input) {
              return $(input).val().split(' - ');
            });

            return [budgetFlights, budgetTimezone()];
          });

          const temp = flightDatesHelper.inactiveByBudgetFlightDates(budgetData);

          if (temp !== budgetFlightDatesInactive) {
            budgetFlightDatesInactive = temp;

            $rootScope.$broadcast('budgetFlightDatesInactiveChange', {
              budgetFlightDatesInactive: budgetFlightDatesInactive,
              applyScope: applyScope
            });
          }
        }, 0);
      };

      const setPacingVisibility = (add_form) => {
        const budgetFlightDatesPacing = add_form.find('input[type="checkbox"][name$="[budget_flight_dates_pacing]"]').prop('checked');

        add_form.find('.budget_pacing').toggleClass('hidden', budgetFlightDatesPacing);
        add_form.find('.budget_flight_date_budget_pacing').toggleClass('hidden', !budgetFlightDatesPacing);
      };

      this.$onInit = function() {
        budgetsElement = $element.parents('#' + self.spendId);
        
        const $closestForm = budgetsElement.closest('form');
        if ($closestForm && $closestForm.length) {
          // round all budget values on form submit
          $closestForm.on('submit', function(e) {
            $('input[id*="_budgets_"][id*="_budget_value"]').each(function() {
                const cleanedValue = cleanNumber($(this).val());
                const convertedValue = Number.parseFloat(cleanedValue);
                if (!isNaN(convertedValue)) {
                  this.value = Math.round(convertedValue);
                }
              });
          });
        }

        bodySelector.on('cocoon:after-insert', '#' + self.spendId, function(e, addedBudget) {
          var that = this;
          addedBudget.find('.budget_pacing .btn-group label[for*=budget_pacing_smooth]').click();
          broadcastSupplyAllocationChange();
          broadcastBudgetCountChange();
          setInitialBudgetCurrency(addedBudget);
          setTimeout(function() {
            setBudgetFlightDatesInactive(true);
            if (self.defaultVastCachingToTrue === 'true' && !addedBudget.find('.budget_vast_caching_adjustment').hasClass('hidden')) {
              addedBudget.find('input[name$="[vast_caching_adjustment]"]').prop('checked', true);
            }
          }, 0);
        });

        bodySelector.on('cocoon:after-insert', '#budget_flight_dates', function(e, addedBudgetFlightDate) {
          const add_form = $(this).closest('.add_form');
          $(this).find('.datehourrange-future').daterangepicker(platformUtilities.dateRangeFutureOptions);
          togglePacingFields(add_form);
          setBudgetFlightDatesInactive(true);
          setPacingVisibility(add_form);
        });

        bodySelector.on('cocoon:after-remove', '#budget_flight_dates', function(e) {
          const add_form = $(this).closest('.add_form');

          setTimeout(function() {
            if (visibleBudgetFlightDates(add_form).length < 1) {
              add_form.find('.flighting-card .delgroup').click();
            }

            setBudgetFlightDatesInactive(true);
          }, 0);
        });

        bodySelector.on('cocoon:after-remove', '#' + self.spendId, function(e) {
          broadcastSupplyAllocationChange();
          broadcastBudgetCountChange();
          setBudgetFlightDatesInactive(true);
        });

        budgetsElement.on('click', '.flighting-activator', function() {
          const add_form = $(this).closest('.add_form');
          setFlightingActive(add_form, true);

          setTimeout(function() {
            if (visibleBudgetFlightDates(add_form).length < 1) {
              add_form.find('.add_budget_flight_date').trigger('click');
            }
          }, 0);
        });

        budgetsElement.on('click', '.flighting-card .delgroup', function() {
          const add_form = $(this).closest('.add_form');
          setFlightingActive(add_form, false);
          visibleBudgetFlightDates(add_form).find('.remove_fields').trigger('click');
          add_form.find('input[type="checkbox"][name$="[budget_flight_dates_pacing]"]').prop('checked', false);

          setTimeout(function() {
            togglePacingFields(add_form);
            setPacingVisibility(add_form);
          }, 0);
        });

        budgetsElement.on('change', 'input[type="checkbox"][name$="[budget_flight_dates_pacing]"]', function() {
          const add_form = $(this).closest('.add_form');
          setPacingVisibility(add_form);
        });

        budgetsElement.on('change', '.budget-period', function() {
          const add_form = $(this).closest('.add_form');
          togglePacingFields(add_form);
        });

        budgetsElement.on('change', '.budget-currency-addon', function() {
          const add_form = $(this).closest('.add_form');
          setupBudgetValueFormatting(add_form)
        });

        budgetsElement.on('change', 'input[name$="[flight_dates]"]', function() {
          setBudgetFlightDatesInactive(true);
        });

        budgetsElement.on('change', 'select[name$="[budget_timezone]"]', function(e) {
          setTimeout(function(){
            $rootScope.$broadcast('budgetTimezoneChange', {
              budgetTimezone: e.target.value
            });
          }, 0);
          setBudgetFlightDatesInactive(true);
        });

        flightDatesElement.on('click', 'label.flight-dates.btn', function() {
          budgetsElement.find('.add_form').each(function(index, add_form) {
            togglePacingFields($(add_form));
          });
        });

        budgetsElement.on('change', 'input[id*=budget_metric]', function() {
          const add_form = $(this).closest('.add_form');
          toggleFieldVisibilityBasedOnMetric(add_form);
          setupBudgetValueFormatting(add_form);
        });

        budgetsElement.on('change', 'input[type="checkbox"][name$="[ignore_supply_allocations]"]', function() {
          broadcastSupplyAllocationChange();
        });

        setTimeout(function() {
          budgetsElement.find('.add_form').each(function(index, add_form) {
            togglePacingFields($(add_form));
            toggleMetricFields($(add_form));
            setupBudgetValueFormatting($(add_form));
            selectAllocationType($(add_form).find('.allocation-breakdown input').is(':checked'), $(add_form));
          });

          setBudgetFlightDatesInactive(true);
        }, 0);

        bodySelector.on('input change', '.budget-cap-percentage input, .budget-value input', function (e) {
          const $input = $(e.target);

          if ($input.closest('.budget-cap-percentage').length) {
            const budget_group = $input.closest('.budget-group');
            const add_form = $input.closest('.add_form');

            const budgetValue = cleanNumber(budget_group.find('.budget-value input').val())
            const percentage = $input.val();
            const metricValue = Math.floor((budgetValue * percentage) / 100);

            add_form.find('.budget-cap-metric-value input').val(metricValue);

          } else if ($input.closest('.budget-value').length) {
            const budgetValue = cleanNumber($input.val())
            const add_form = $input.closest('.add_form');
            setupBudgetValueFormatting(add_form);
            add_form.find('.budget-caps:not([style*="display: none"])').each(function (_, budgetCap) {
              const $budgetCap = $(budgetCap);
              if ($budgetCap.find('.budget-cap-percentage input').is(':visible')) {
                const percentage = $budgetCap.find('.budget-cap-percentage input').val();
                const metricValue = Math.floor((budgetValue * percentage) / 100);
                $budgetCap.find('.budget-cap-metric-value input').val(metricValue);
              }
            });
          }
        });

        const setBudgetCapActive = function(add_form, budgetCapsActive) {
          add_form.find('.allocation-breakdown').toggleClass('active', budgetCapsActive);
          add_form.find('.allocation-type').toggleClass('hidden', !budgetCapsActive);
          add_form.find('.budget-cap-card').toggleClass('hidden', !budgetCapsActive);
        };

        const setBudgetAllocationActive = function(add_form, budgetAllocationsActive) {
          add_form.find('.allocation-breakdown').toggleClass('active', budgetAllocationsActive);
          add_form.find('.allocation-type').toggleClass('hidden', !budgetAllocationsActive);
          add_form.find('.budget-allocation-card').toggleClass('hidden', !budgetAllocationsActive);
        };

        budgetCapsObjectOptionDisabler = new SelectOptionDisabler(
            '.nested-fields:not([style*="display: none"]) .budget-cap-allocation-object select'
        );

        var setBudgetCaps = function () {
          const group = budgetsElement.find('.groupedAssociations');

          setDividerVisibility(group.find('.add_form.budget-caps'));
        };
        var setBudgetAllocations = function () {
          const group = budgetsElement.find('.groupedAssociations');

          setDividerVisibility(group.find('.add_form.budget-allocations'));
        };

        var setDividerVisibility = function(budgetCaps) {
          $.each(budgetCaps, function(index, group) {

            var budgetCapName = index + 1;
            $(budgetCaps).find('.group-name').text(budgetCapName);
            $(budgetCaps).find('.group-input').val(budgetCapName);
          });

          $.each(budgetCaps, function(index, budgetCap) {
            if (budgetCaps.length < 2) {
              $(budgetCap).find('.and').addClass('hidden');
            }
            else {
              $(budgetCap).find('.and').removeClass('hidden');
              var lastVisibleAddForm = _.last(budgetCaps);
              $(lastVisibleAddForm).find('.and').addClass('hidden');
            }
          });
        };

        var toggleBudgetCapsValueAndIdsVisibility = function(add_form) {
          var sourceType = add_form.find('.budget-cap-allocation-source-type input:checked').val();
          var budgetAllocationObject = add_form.find('.budget-cap-allocation-object select option:selected').val();
          var idsAttribute = add_form.find('.budget-cap-allocation-object select option:selected').data('associationIdsAttr');
          var idsAttributePresent = idsAttribute !== '';

          if (sourceType === 'values') {
            if (budgetAllocationObject === 'StreamingSellerSeat') {
              add_form.find('.budget-cap-allocation-values.budget-cap-streaming_seller_seat-values').toggleClass('hidden', false).attr('disabled', false);
              add_form.find('.budget-cap-allocation-values:not(.budget-cap-streaming_seller_seat-values').toggleClass('hidden', true).attr('disabled', true);
            } else {
              add_form.find('.budget-cap-allocation-values.budget-cap-allocation-object-values').toggleClass('hidden', false).attr('disabled', false);
              add_form.find('.budget-cap-allocation-values:not(.budget-cap-allocation-object-values').toggleClass('hidden', true).attr('disabled', true);
            }
          } else {
            add_form.find('.budget-cap-allocation-values').toggleClass('hidden', true).attr('disabled', true);
          }

          add_form.find('.budget-cap-allocation-list-ids').addClass('hidden');

          if (sourceType === 'list' && idsAttributePresent) {
            add_form.find('.budget-cap-allocation-list-ids.budget-cap-' + idsAttribute).removeClass('hidden');
          }
        };

        bodySelector.on('change', '.budget-cap-allocation-source-type input', function(e) {
          var add_form = $(e.target).closest('.add_form');
          toggleBudgetCapsValueAndIdsVisibility(add_form);

        });

        bodySelector.on('change', '.budget-cap-budget-type input', function(e) {
          const add_form = $(e.target).closest('.add_form');
          const budgetType = add_form.find('.budget-cap-budget-type input:checked').val();
          const budgetValue = cleanNumber($(this).closest('.budget-group').find('.budget-value input').val())
          if (budgetType !== 'percent') {
            add_form.find('.budget-cap-percentage').addClass('hidden');
            add_form.find('#budget_cap_metric_value_field').attr('disabled', false);

            const budgetCapPercentage = add_form.find('.budget-cap-percentage input').val();
            add_form.find('.budget-cap-metric-value input').val(Math.floor((budgetValue * budgetCapPercentage) / 100));
          } else {
            add_form.find('.budget-cap-percentage').removeClass('hidden');
            add_form.find('#budget_cap_metric_value_field').attr('disabled', true);

            const budgetCapMetricValue = add_form.find('#budget_cap_metric_value_field').val()
            add_form.find('.budget-cap-percentage input').val(Math.round((budgetCapMetricValue / budgetValue) * 100));
          }
        });

        bodySelector.on('change', '.budget-metric input', function(e) {
          var selectedType = $(e.target).val();
          var addForm = $(e.target).closest('.add_form');
          updateBudgetCapLabels(addForm, selectedType);
          toggleMetricFields(addForm)
        });

        bodySelector.on('change', '.budget-cap-allocation-object select', function(e) {
          var budgetCapsObject = $(this).val();
          var budgetCapsObjectSelected = budgetCapsObject !== '';
          var add_form = $(e.target).closest('.add_form');

          add_form.find('.budget-cap-allocation-values select option').remove();
          add_form.find('.budget-cap-allocation-values select').val([]).trigger('chosen:updated');
          add_form.find('.budget-cap-list-type, .budget-cap-allocation-source-type').toggleClass('hidden', !budgetCapsObjectSelected);

          toggleBudgetCapsValueAndIdsVisibility(add_form);
        });

        function compileAngularJsElements(insertedItem) {
          // only apply this to specific elements because our ``{{CONTENT_ATTRIBUTE_NAME}}` content targeting values get overwritten by AngularJS
          $(insertedItem).find(".angularjs-compile").each((i, compileElement) => {
            // because this is Cocoon, and not AngularJS, we need to tell AngularJS to compile and initialize the new DOM nodes
            $rootScope.$apply(() => {
              const scope = angular.element(compileElement).scope();
              $compile(compileElement)(scope);
            });
          });
        }

        bodySelector.on('cocoon:after-insert', '#budget_caps', function(e, insertedItem) {
          compileAngularJsElements(insertedItem);

          const group = $(e.target).closest('.groupedAssociations');
          const add_form = $(this).closest('.add_form');
          const budgetMetric = add_form.find('input[id*=budget_metric]:checked').val();
          const budgetCaps = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          const label = add_form.find('.budget-cap-metric-value-label').last();

          label.text(budgetMetric.charAt(0).toUpperCase() + budgetMetric.slice(1) + ':');

          add_form.find('.budget-cap-budget-type .btn').not('.btn-percent').not('.hidden').last().addClass('active');
          add_form.find('.budget-cap-budget-type .btn input[type="radio"]').not('.btn-percent').not('.hidden').last().prop('checked', true)
          const lastBudgetCap = add_form.find('.budget-caps:not([style*="display: none"]):last');

          const budgetTypeContainer = lastBudgetCap.find('.budget-cap-budget-type');
          const allButtons = budgetTypeContainer.find('.btn');
          const nonPercentButtons = allButtons.not('.btn-percent');
          const targetButton = budgetTypeContainer.find('.' + typeToClassMap[budgetMetric]);

          nonPercentButtons.addClass('hidden');
          targetButton.removeClass('hidden');

          const activeButton = nonPercentButtons.not('.hidden').addClass('active');
          activeButton.find('input[type="radio"]').prop('checked', true);
          allButtons.not(activeButton).removeClass('active');

          initChosenSelects(group);
          setDividerVisibility(budgetCaps);
        });

        bodySelector.on('cocoon:after-insert', '#budget_allocations', function(e, insertedItem) {
          compileAngularJsElements(insertedItem);

          const budgetAllocations = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          initChosenSelects($(e.target).closest('.groupedAssociations'));
          setDividerVisibility(budgetAllocations);
        });

        bodySelector.on('cocoon:after-remove', '#budget_caps', function(e) {
          const add_form = $(this).closest('.add_form');
          const budgetCaps = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          if (budgetCaps.length  === 0) {
            add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
            setBudgetCapActive(add_form, false);
            toggleMetricFields(add_form)
          }

          setDividerVisibility(budgetCaps);
        });

        bodySelector.on('cocoon:after-remove', '#budget_allocations', function(e) {
          const add_form = $(this).closest('.add_form');
          const budgetAllocations = $(e.target).closest('.groupedAssociations').find('div:not(.newgroup) .add_form:not([style*="display: none"])').not('.hidden');
          if (budgetAllocations.length  === 0) {
            add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
            setBudgetAllocationActive(add_form, false);
            toggleMetricFields(add_form);
          }

          setDividerVisibility(budgetAllocations);
        });

        const visibleBudgetCaps = function(add_form) {
          return add_form.find('.budget-caps:not([style*="display: none"])').not('.hidden');
        };

        const visibleBudgetAllocations = function(add_form) {
          return add_form.find('.budget-allocations:not([style*="display: none"])').not('.hidden');
        };

        const renderInitialBudgetGroups = (add_form) => {
          const allocation_breakdown = add_form.find('.allocation-breakdown input').is(':checked');
          const budgetCapsSize = add_form.find('.budget-caps:not([style*="display: none"])').length
          const budgetAllocationsSize = add_form.find('.budget-allocations:not([style*="display: none"])').length
          const isBudgetCap = add_form.find('.allocation-type input[type="radio"]:checked').val() === 'budget_cap';
          if (isBudgetCap) {
            if (allocation_breakdown && budgetCapsSize === 0) {
              add_form.find('.add_budget_cap').trigger('click');
              add_form.find('.budget-cap-budget-type .btn').not('.btn-percent').not('.hidden').addClass('active');
              add_form.find('.budget-cap-budget-type .btn input[type="radio"]').not('.btn-percent').not('.hidden').last().prop('checked', true)
            }
            setBudgetCapActive(add_form, allocation_breakdown);
          } else if (!isBudgetCap) {
            if (allocation_breakdown && budgetAllocationsSize === 0)
            {
              add_form.find('.add_budget_allocation').trigger('click');
              add_form.find('.add_budget_allocation').trigger('click');
            }
            setBudgetAllocationActive(add_form, allocation_breakdown);
          }
        }

        const selectAllocationType = (allocationBreakdown, add_form) => {
          if (allocationBreakdown && add_form.find('.allocation-type input[type="radio"]:checked').val() === undefined) {
            const hasAllocation = add_form.find('input[id*="allocation_type__allocation"]').length > 0;
            const hasBudgetCap = add_form.find('input[id*="allocation_type_budget_cap"]').length > 0;
            let targetValue = null;
            if (hasAllocation) {
              targetValue = '%_allocation';
            } else if (hasBudgetCap) {
              targetValue = 'budget_cap';
            }

            if (targetValue) {
              add_form.find(`.allocation-type input[type="radio"][value="${targetValue}"]`).closest('label').click();
            }
          }
        }

        bodySelector.on('click', '.allocation-breakdown', function (e) {
          const add_form = $(this).closest('.add_form');

          renderInitialBudgetGroups(add_form);
          toggleMetricFields(add_form);
          selectAllocationType(e.target.checked, add_form);
        });

        bodySelector.on('click', '.budget-cap-card .budget-cap-delgroup', function(e) {
          const add_form = $(this).closest('.add_form');
          setBudgetCapActive(add_form, false);
          visibleBudgetCaps(add_form).find('.remove_fields').trigger('click');
          toggleMetricFields(add_form)
          add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
        });

        bodySelector.on('click', '.budget-allocation-card .budget-allocation-delgroup', function(e) {
          const add_form = $(this).closest('.add_form');
          setBudgetAllocationActive(add_form, false);
          visibleBudgetAllocations(add_form).find('.remove_fields').trigger('click');
          add_form.find('input[type="checkbox"][name$="[allocation_breakdown]"]').prop('checked', false);
          toggleMetricFields(add_form);
        });

        bodySelector.on('change', '.allocation-type', function () {
          const add_form = $(this).closest('.add_form');
          const isBudgetCap = add_form.find('.allocation-type input[type="radio"]:checked').val() === 'budget_cap';
          add_form.find('.budget-cap-card').toggleClass('hidden', !isBudgetCap);
          add_form.find('.budget-allocation-card').toggleClass('hidden', isBudgetCap);

          renderInitialBudgetGroups(add_form)
        });

        var initChosenSelects = function(selector) {
          $.each($(selector).find('select[data-ajax]:not([data-tom-select])'), function(index, select){
            var selector = $(select);
            if (selector.data('ajax') === 'select' || selector.parent().find('.tokenize').length < 1) {
              selector.defaultTokenize();
            }
          });
          $.each($(selector).find('select[data-tom-select]'), function(index, select){
            $(select).defaultTomSelect();
          });
          $.each($(selector).find('select[data-dynamic-chosen]'), function(index, select){
            $(select).dynamicChosen();
          });
          $.each($(selector).find('select:not([data-ajax]):not([data-tom-select]):not([data-dynamic-chosen])'), function(index, select){
            $(select).defaultChosen();
          });
        };

        setBudgetCaps()
        setBudgetAllocations()
      };

    }]
  });
